import React from 'react';
import { Chip, Tooltip, chipClasses } from '@mui/material';
import {
  Error as ErrorIcon,
  HourglassTop as HourglassTopIcon,
  Launch as LaunchIcon,
  PlayArrow as PlayArrowIcon,
} from '@mui/icons-material';
import { LiveCrStatus } from 'components/CleanRooms/CrLiveCleanRoom/constant';
import { liveCleanRoomPath } from 'utils/spaUrls';
import { useHistory } from 'react-router-dom';


const statusMap = {
  [LiveCrStatus.LIVE_CR_INITIATED]: {
    label: 'Initiated',
    icon: <HourglassTopIcon fontSize='small' />,
    backgroundColor: '#d1d5db',
    borderColor: '#9ca3af',
    color: '#4b5563',
    iconColor: '#6b7280',
    tooltip: 'The session has been initiated. Awaiting setup.',
  },
  [LiveCrStatus.LIVE_CR_INITIALIZING]: {
    label: 'Initializing',
    icon: <HourglassTopIcon fontSize='small' />,
    backgroundColor: '#fef9c3',
    borderColor: '#fde047',
    color: '#854d0e',
    iconColor: '#eab308',
    tooltip: 'Your live cleanroom session is being set up. Please wait.',
  },
  [LiveCrStatus.LIVE_CR_ACTIVE]: {
    label: 'Live',
    icon: <PlayArrowIcon fontSize='small' />,
    backgroundColor: '#dcfce7',
    hoverBackground: '#bbf7d0',
    borderColor: '#86efac',
    color: '#166534',
    iconColor: '#4ade80',
    tooltip: 'Your live cleanroom session is now active. You can begin working.',
  },
  [LiveCrStatus.LIVE_CR_FAILED]: {
    label: 'Error',
    icon: <ErrorIcon fontSize='small' />,
    backgroundColor: '#fee2e2',
    borderColor: '#fca5a5',
    color: '#9b2226',
    iconColor: '#ef4444',
    tooltip: 'There was an error during the session. Please check and try again.',
  },
};

const LiveCrStatusChip = ({ cleanRoomId, status, liveCleanRoom }) => {
  const history = useHistory();

  const config = statusMap[status];

  if (!config) return null;

  const isLive = status === LiveCrStatus.LIVE_CR_ACTIVE;

  const handleStatusClick = () => {
    history.push(liveCleanRoomPath.landing(cleanRoomId, liveCleanRoom.ID));
  };

  return (
    <Tooltip title={config.tooltip} arrow placement='left'>
      <Chip
        icon={config.icon}
        label={(
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {config.label}
            {isLive && (
              <LaunchIcon
                className='hover-arrow'
                sx={{
                  color: config.color,
                  marginLeft: 1,
                  display: 'none',
                  fontSize: '1rem',
                }}
              />
            )}
          </span>
        )}
        onClick={isLive ? handleStatusClick : undefined}
        sx={{
          backgroundColor: config.backgroundColor,
          border: `1px solid ${config.borderColor}`,
          color: config.color,
          borderRadius: '16px',
          typography: 'subtitle2',
          cursor: isLive ? 'pointer' : 'default',
          [`& .${chipClasses.icon}`]: {
            color: config.iconColor,
          },
          '&:hover': isLive
            ? {
              backgroundColor: config.hoverBackground,
              '& .hover-arrow': {
                display: 'block',
              },
            }
            : {},
        }}
      />
    </Tooltip>
  );
};

export default LiveCrStatusChip;
